import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Teleport as _Teleport } from "vue"

const _hoisted_1 = { class: "payment" }
const _hoisted_2 = { class: "payment-header" }
const _hoisted_3 = { class: "payment-header--title" }
const _hoisted_4 = { class: "caption-medium bold" }
const _hoisted_5 = { class: "payment-body form-screen__body" }
const _hoisted_6 = { class: "payment-body--input payment-input" }
const _hoisted_7 = {
  key: 0,
  class: "payment-body--tabs"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  key: 1,
  class: "payment-body--note"
}
const _hoisted_10 = { class: "caption-medium color-text-secondary" }
const _hoisted_11 = { class: "payment-body--email" }
const _hoisted_12 = { class: "payment-body--email_title" }
const _hoisted_13 = { class: "h3" }
const _hoisted_14 = { class: "payment-body--email_subtitle" }
const _hoisted_15 = { class: "caption-select" }
const _hoisted_16 = { class: "payment-body--email_input" }
const _hoisted_17 = {
  key: 0,
  class: "payment-body--email_error"
}
const _hoisted_18 = { class: "caption-small color-error" }
const _hoisted_19 = { class: "payment-body--btn form-screen__footer" }

import { computed, onMounted, ref, reactive } from "vue";
import type { ComponentPublicInstance } from "vue";
import BaseButton from "@/components/base/BaseButton.vue";
import type { CreatePaymentType } from "@/struct/PaymentStruct";
import BaseModal from "@/components/base/BaseModal.vue";
import BaseInput from "@/components/base/BaseInput.vue";
import { setLocalStorageParams, getLocalStorageParams } from "@/utils/common";
import { useRouter } from "vue-router";
import { InputNumber } from "primevue";
import BaseFigureForIcon from "@/components/base/BaseFigureForIcon.vue";
import { useStore } from "@/store";
import { useI18n } from "vue-i18n";

interface ModalStates {
  [key: string]: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'PaymentPage',
  setup(__props) {

const { t } = useI18n();

const router = useRouter();
const store = useStore();

const symbolPosition = ref<string>("60px");
const inputValue = ref<number>(0);
// BaseButton — компонент, поэтому в ref лежит его инстанс, а не сам <button>.
const submitBtn = ref<ComponentPublicInstance | null>(null);

const emailInputValue = ref<string>(
  getLocalStorageParams("paymentEmail") || ""
);
const isEmailError = ref<boolean>(false);
const isValidEmail = ref<boolean>(false);
const currentMsisdn = ref<string>("");
const isLoading = ref<boolean>(false);
const activePaymentOption = ref<"card" | "sber">("card");

//modal states & methods
const modalStates = reactive<ModalStates>({
  errorModal: false,
  paymentModal: false,
  // Add as many modals as you need
});

const toggleModal = (state: boolean, name: string): void => {
  if (name in modalStates) {
    modalStates[name] = state;
  } else {
    console.warn(`Modal "${name}" does not exist.`);
  }
};

//price input methods
const presetPrices = ref<{ amount: number; active: boolean }[]>([
  {
    amount: 50,
    active: false,
  },
  {
    amount: 100,
    active: false,
  },
  {
    amount: 200,
    active: false,
  },
  {
    amount: 300,
    active: false,
  },
  {
    amount: 500,
    active: false,
  },
]);
const currentUserPhone = computed<number>(
  () => store.getters["tariff/currentUserPhone"]
);

const pickPresetPrice = (id: number) => {
  presetPrices.value.forEach((item) => {
    item.active = false;
  });
  let item = presetPrices.value[id];
  item.active = true;
  inputValue.value = item.amount;
  if (item.amount < 100) {
    symbolPosition.value = "90px";
  } else if (item.amount === 100) {
    symbolPosition.value = "110px";
  } else {
    symbolPosition.value = "120px";
  }
};

const isCorrectValue = computed(() => {
  return inputValue.value >= 10 && inputValue.value <= 15000;
});

//email input methods

const validateEmail = (isValid: boolean): void => {
  console.log(isValid);
  isEmailError.value = !isValid;
  isValidEmail.value = emailInputValue.value && isValid;
};

const toPayment = async () => {
  const el = submitBtn.value?.$el;
  if (el instanceof HTMLButtonElement) {
    el.blur();
  }
  isLoading.value = true;
  setLocalStorageParams("paymentEmail", emailInputValue.value);
  if (activePaymentOption.value === "sber") {
    window.open("https://sberbank.com/sms/mybill?cs=2116856134125", "_self");
    toggleModal(false, "paymentModal");
    isLoading.value = false;
  } else {
    const payload: CreatePaymentType = {
      msisdn: currentMsisdn.value,
      email: emailInputValue.value,
      amount: inputValue.value,
    };
    store
      .dispatch("customer/toPaymentCart", payload)
      .then((date) => {
        if (date?.REF) {
          window.open(date.REF, "_self");
        }
      })
      .finally(() => {
        isLoading.value = false;
        toggleModal(false, "paymentModal");
      });
  }
};

const keepNumbersAndLeadingPlus = (input: string) => {
  // Remove everything except digits and pluses
  let cleaned = input.replace(/[^0-9+]/g, "");
  // If there’s a plus not at the start, remove it
  cleaned = cleaned.replace(/(?!^)\+/g, "");
  // If there are multiple pluses at the start, keep only one
  cleaned = cleaned.replace(/^\++/, "+");
  return cleaned;
};

const goBack = () => {
  router.back();
};

const tabClasses = (active: boolean) => {
  return [active ? "active" : ""];
};

onMounted(() => {
  if (getLocalStorageParams("paymentMethod")) {
    activePaymentOption.value = getLocalStorageParams("paymentMethod") as
      | "card"
      | "sber";
  }
  currentMsisdn.value = keepNumbersAndLeadingPlus(
    String(currentUserPhone.value)
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "payment-header--back",
          onClick: goBack
        }, [
          _createVNode(BaseFigureForIcon, {
            size: "medium",
            color: "white",
            icon: "arrow",
            position: "left",
            "is-button": ""
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)("payment.page.title")), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(InputNumber), {
            modelValue: inputValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
            class: "payment-input",
            inputId: "payment-input",
            suffix: "₽",
            placeholder: "0₽",
            fluid: ""
          }, null, 8, ["modelValue"])
        ]),
        (inputValue.value === 0 || inputValue.value == null)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(presetPrices.value, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass(["payment-body--tabs-item", tabClasses(item.active)]),
                  onClick: ($event: any) => (pickPresetPrice(index))
                }, [
                  _createElementVNode("p", {
                    class: _normalizeClass(["caption-medium", item.active ? 'color-white' : ''])
                  }, _toDisplayString(item.amount) + "₽ ", 3)
                ], 10, _hoisted_8))
              }), 128))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)("payment.page.amountHint")), 1)
            ])),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(t)("payment.page.emailTitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("p", _hoisted_15, _toDisplayString(_unref(t)("payment.page.emailSubtitle")), 1)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(BaseInput, {
              modelValue: emailInputValue.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((emailInputValue).value = $event)),
              onFocus: _cache[2] || (_cache[2] = ($event: any) => (isValidEmail.value = false)),
              onValidation: validateEmail,
              "has-error": isEmailError.value,
              type: "email",
              placeholder: _unref(t)('payment.page.emailPlaceholder')
            }, null, 8, ["modelValue", "has-error", "placeholder"])
          ]),
          (isEmailError.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("p", _hoisted_18, _toDisplayString(_unref(t)("payment.page.emailError")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(BaseButton, {
            ref_key: "submitBtn",
            ref: submitBtn,
            title: _unref(t)('payment.page.topUp'),
            disabled: 
            !isCorrectValue.value ||
            isLoading.value ||
            isEmailError.value ||
            !emailInputValue.value ||
            !isValidEmail.value
          ,
            onClick: toPayment
          }, null, 8, ["title", "disabled"])
        ])
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: ".root" }, [
      (modalStates.errorModal)
        ? (_openBlock(), _createBlock(BaseModal, {
            key: 0,
            title: _unref(t)('common.errors.title'),
            "main-btn-title": _unref(t)('payment.page.errorClose'),
            onClose: _cache[3] || (_cache[3] = ($event: any) => (toggleModal(false, 'errorModal'))),
            onAction: _cache[4] || (_cache[4] = ($event: any) => (toggleModal(false, 'errorModal')))
          }, null, 8, ["title", "main-btn-title"]))
        : _createCommentVNode("", true)
    ]))
  ], 64))
}
}

})